import { platformNewsItemSectionsEnum } from "helpers/enums";
import { OdataFilters, queryCollection } from "helpers/reqparams";
import { alertRequest, body, request } from "services/request";

const resource = "api/platformNews";
const resourcesQuery = { orderBy: "id desc" };

const index = ({ preparedFilter, ...params }: OdataFilters) => {
    const query = queryCollection(params, { filter: preparedFilter, ...resourcesQuery });
    return request(`${resource}/getlist${query}`, { method: "GET" }, { countInHeaders: true });
};

const getListForView = ({
    preparedFilter,
    section,
    ...params
}: OdataFilters & { section: keyof typeof platformNewsItemSectionsEnum }) => {
    const query = queryCollection(params, { filter: { ...preparedFilter, section }, ...resourcesQuery });
    return request(`${resource}/getListForView${query}`, { method: "GET" }, { countInHeaders: true });
};

const getLastNews = () => {
    const query = queryCollection({ length: 5 }, { ...resourcesQuery });
    return request(`${resource}/getListForView${query}`, { method: "GET" });
};

const apply = (params: {}) => alertRequest(`${resource}/apply`, body(params));
const markAsRead = (params: {}) => request(`${resource}/markAsRead`, body(params));
const setGrade = (params: {}) => request(`${resource}/setGrade`, body(params));
const uploadFile = (params: {}) => alertRequest(`${resource}/uploadFile`, params);
const getItem = ({ id }: { id: number }) => request(`${resource}/get/${id}`, { method: "GET" });
const getForView = (id: number) => request(`${resource}/getForView/${id}`, { method: "GET" });
const getUnreadPlatformNewsCount = () => request(`${resource}/getUnreadPlatformNewsCount`, { method: "GET" });
const delItem = (params: {}) => alertRequest(`${resource}/delete`, body(params));

export {
    index,
    apply,
    getItem,
    delItem,
    uploadFile,
    getListForView,
    markAsRead,
    setGrade,
    getForView,
    getUnreadPlatformNewsCount,
    getLastNews,
};
